import React, { useEffect, useState } from "react";
import "./condominium.css";

import condominiumData from "../../constantes/condominiumData";
import condominiumImages from "../../constantes/condominiumImages";
import raizesLogo from "../../assets/condominium/raizes-logo.png";

const ArrowIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14" />
    <path d="m13 6 6 6-6 6" />
  </svg>
);

const CheckIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m5 12 4 4L19 6" />
  </svg>
);

const MapIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M9 18 3 21V6l6-3 6 3 6-3v15l-6 3-6-3Z" />
    <path d="M9 3v15" />
    <path d="M15 6v15" />
  </svg>
);

const PresentationIcon = ({ name }) => {
  const common = { viewBox: "0 0 48 48", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" };
  if (name === "trees") return <svg {...common}><path d="M13 29V41M35 27v14M8 29h10l-5-8-5 8ZM5 21h16l-8-13-8 13ZM29 27h12l-6-10-6 10ZM25 17h18L34 4l-9 13ZM8 41h32" /></svg>;
  if (name === "bedrooms") return <svg {...common}><path d="M6 37V14M6 31h36v6M42 37V23a4 4 0 0 0-4-4H18v12M18 27h24M10 22h4a4 4 0 0 1 4 4v5H6v-5a4 4 0 0 1 4-4Z" /></svg>;
  if (name === "security") return <svg {...common}><path d="M8 18h20l8 6-8 6H8a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3ZM36 24l7-5v10l-7-5ZM17 31v8M12 39h10M12 13l5-5 5 5M17 8v10" /></svg>;
  return <svg {...common}><circle cx="17" cy="15" r="5" /><circle cx="32" cy="17" r="4" /><path d="M7 38v-3a10 10 0 0 1 20 0v3H7ZM28 27a8 8 0 0 1 13 6v3H30" /></svg>;
};

const CloseIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="22"
    height="22"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M6 6 18 18" />
    <path d="M18 6 6 18" />
  </svg>
);

const Condominium = () => {
  const [showContact, setShowContact] = useState(false);
  const [showHeroContact, setShowHeroContact] = useState(false);
  const [activeInfrastructureSlide, setActiveInfrastructureSlide] = useState(0);
  const [infrastructureDetailsOpen, setInfrastructureDetailsOpen] = useState(false);
  const [activePlantSlide, setActivePlantSlide] = useState(0);
  const [activeGalleryImage, setActiveGalleryImage] = useState(0);
  const [galleryViewerOpen, setGalleryViewerOpen] = useState(false);
  const [locationMapMode, setLocationMapMode] = useState("map");

  const {
    name,
    hero,
    location,
    infrastructure,
    plants,
    contact,
  } = condominiumData;

  const infrastructureImages =
    condominiumImages.infrastructure || [];

  const galleryImages =
    condominiumImages.gallery || [];

  const locationMapEmbedUrl = `https://maps.google.com/maps?q=${encodeURIComponent(location.address)}&t=${locationMapMode === "satellite" ? "k" : "m"}&z=16&output=embed`;

  const openGalleryViewer = (index) => {
    setActiveGalleryImage(index);
    setGalleryViewerOpen(true);
  };

  const changeGalleryImage = (direction) => {
    setActiveGalleryImage((index) =>
      (index + direction + galleryImages.length) % galleryImages.length
    );
  };

  useEffect(() => {
    if (!galleryViewerOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    const handleGalleryKeyDown = (event) => {
      if (event.key === "Escape") setGalleryViewerOpen(false);
      if (event.key === "ArrowRight") {
        setActiveGalleryImage((index) => (index + 1) % galleryImages.length);
      }
      if (event.key === "ArrowLeft") {
        setActiveGalleryImage((index) => (index - 1 + galleryImages.length) % galleryImages.length);
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleGalleryKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleGalleryKeyDown);
    };
  }, [galleryViewerOpen, galleryImages.length]);

  const plantImages =
    condominiumImages.plants || [];

  const infrastructureSlides = [
    {
      title: "Espaços para aproveitar todos os dias",
      description: "Ambientes planejados para lazer, convivência e praticidade, criando uma experiência completa dentro do próprio condomínio.",
    },
    {
      title: infrastructure.items?.[3] || "Quadra poliesportiva",
      description: "Um espaço para praticar esportes, se movimentar e aproveitar momentos de lazer com a família.",
    },
    {
      title: infrastructure.items?.[4] || "Playground",
      description: "Um ambiente pensado para as crianças brincarem e para a família aproveitar bons momentos ao ar livre.",
    },
  ].slice(0, infrastructureImages.length);

  const openContact = () => {
    setShowContact(true);
  };

  const closeContact = () => {
    setShowContact(false);
  };

  const openHeroContact = () => setShowHeroContact(true);
  const closeHeroContact = () => setShowHeroContact(false);

  const sectionActions = (href, label, variant) => (
    <div className={`condominium-section-actions condominium-actions--${variant}`}>
      <a className="condominium-section-next" href={href}>{label}<ArrowIcon /></a>
      <button type="button" className="condominium-section-contact" onClick={openContact} aria-label="Fale conosco sobre o Raízes Residencial Clube">Venha conhecer<ArrowIcon /></button>
    </div>
  );

  return (
    <main className="condominium-page">

      {/* =========================================================
          HERO
      ========================================================= */}

      <section className="condominium-hero">

        <img
          className="condominium-hero-image"
          src={condominiumImages.hero}
          alt={name}
        />

        <div className="condominium-hero-overlay" />

        <div className="condominium-container condominium-hero-content">

          <div className="condominium-hero-copy">

            <div className="condominium-hero-brand">
              <span className="condominium-hero-brand-rule" aria-hidden="true" />
              <img
                className="condominium-hero-brand-logo"
                src={raizesLogo}
                alt={hero.label}
              />
            </div>

            <h1>{hero.title}</h1>

            <p>{hero.description}</p>

            <a
              className="condominium-primary-button"
              href="#empreendimento"
            >
              Conheça o empreendimento
              <ArrowIcon />
            </a>

          </div>

        </div>

        {/* =========================================================
            CTA FIXO NO HERO
        ========================================================= */}

        <div
          className={`condominium-hero-contact ${
            showContact ? "is-open" : ""
          }`}
        >

          {!showHeroContact ? (
            <button type="button" className="condominium-hero-contact-trigger" onClick={openHeroContact} aria-label="Venha conhecer o empreendimento" aria-expanded="false">
              <span className="condominium-hero-contact-label">VENHA CONHECER</span>
              <span className="condominium-hero-contact-title">Raízes Residencial Clube</span>
              <span className="condominium-hero-contact-arrow"><ArrowIcon /></span>
            </button>
          ) : (
            <div className="condominium-hero-contact-panel" role="dialog" aria-label="Contato do empreendimento">
              <button type="button" className="condominium-hero-contact-close" onClick={closeHeroContact} aria-label="Fechar"><CloseIcon /></button>
              <span className="condominium-eyebrow condominium-eyebrow-dark">FALE CONOSCO</span>
              <h3>Venha conhecer o<strong> Raízes.</strong></h3>
              <p>Consulte as unidades disponíveis e agende uma visita ao empreendimento.</p>
              <a className="condominium-hero-contact-whatsapp" href={contact.whatsapp} target="_blank" rel="noopener noreferrer">Falar pelo WhatsApp<ArrowIcon /></a>
              <button type="button" className="condominium-hero-contact-minimize" onClick={closeHeroContact}>Fechar</button>
            </div>
          )}

        </div>

        <div className="condominium-hero-scroll">
          <span>Role para conhecer</span>
          <span className="condominium-scroll-line" />
        </div>

      </section>


      {/* =========================================================
          APRESENTAÇÃO
      ========================================================= */}

      <section className="condominium-introduction" id="empreendimento">
        <div className="condominium-container">
          <header className="condominium-introduction-heading">
            <span className="condominium-eyebrow condominium-eyebrow-dark">
              RAÍZES RESIDENCIAL CLUBE
            </span>
            <h2>
              Um lugar pensado para
              <br />
              <strong>viver bem.</strong>
            </h2>
          </header>
          <div className="condominium-presentation-cards">
            <article className="condominium-presentation-card">
              <span className="condominium-presentation-icon"><PresentationIcon name="trees" /></span>
              <h3>Área verde</h3>
              <p>Árvores e espaços ao ar livre para aproveitar o condomínio.</p>
            </article>
            <article className="condominium-presentation-card">
              <span className="condominium-presentation-icon"><PresentationIcon name="bedrooms" /></span>
              <h3>2 dormitórios</h3>
              <p>Apartamentos pensados para o conforto da família.</p>
            </article>
            <article className="condominium-presentation-card">
              <span className="condominium-presentation-icon"><PresentationIcon name="security" /></span>
              <h3>Segurança</h3>
              <p>Condomínio fechado para mais tranquilidade no dia a dia.</p>
            </article>
            <article className="condominium-presentation-card">
              <span className="condominium-presentation-icon"><PresentationIcon name="people" /></span>
              <h3>Área de convivência</h3>
              <p>Espaços de lazer para compartilhar bons momentos.</p>
            </article>
          </div>
          {sectionActions("#localizacao", "Conheça a localização", "intro")}
        </div>
      </section>


      {/* =========================================================
          LOCALIZAÇÃO
      ========================================================= */}

      <section className="condominium-location" id="localizacao">

        <div className="condominium-container condominium-location-grid">

          <div className="condominium-location-image condominium-location-map-container">
            <div className="condominium-location-map-tools" role="group" aria-label="Tipo de mapa">
              <button type="button" className={locationMapMode === "map" ? "is-active" : ""} aria-pressed={locationMapMode === "map"} onClick={() => setLocationMapMode("map")}>Mapa</button>
              <button type="button" className={locationMapMode === "satellite" ? "is-active" : ""} aria-pressed={locationMapMode === "satellite"} onClick={() => setLocationMapMode("satellite")}>Satélite</button>
            </div>
            <iframe
              className="condominium-location-map-frame"
              title={`Mapa do endereço ${location.address}`}
              src={locationMapEmbedUrl}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          <div className="condominium-location-content">

            <span className="condominium-eyebrow condominium-eyebrow-dark">
              LOCALIZAÇÃO
            </span>

            <h2>{location.title}</h2>

            <div className="condominium-location-description">

              {location.description?.map((paragraph, index) => (
                <p key={index}>
                  {paragraph}
                </p>
              ))}

            </div>

            <div className="condominium-address">

              <span className="condominium-icon-box">
                <MapIcon />
              </span>

              <div>

                <span className="condominium-small-label">
                  Endereço
                </span>

                <strong>
                  {location.address}
                </strong>

              </div>

            </div>

            <a
              className="condominium-outline-button"
              href={location.mapUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Ver localização no mapa
              <ArrowIcon />
            </a>

            {sectionActions("#infraestrutura", "Conheça a estrutura", "location")}

          </div>

        </div>

      </section>


      {/* =========================================================
          INFRAESTRUTURA
      ========================================================= */}

      <section
        className="condominium-infrastructure"
        id="infraestrutura"
      >

        <div className="condominium-container">

          <div className="condominium-section-header">

            <div>

              <span className="condominium-eyebrow condominium-eyebrow-dark">
                INFRAESTRUTURA
              </span>

              <h2>
                {infrastructure.title}
              </h2>

            </div>

          </div>


          {infrastructureSlides.length > 0 && (
            <div className="condominium-infrastructure-carousel" role="region" aria-roledescription="carrossel" aria-label="Infraestrutura do condomínio">
              <div className="condominium-infrastructure-slide" key={activeInfrastructureSlide}>
                <img className="condominium-infrastructure-slide-image" src={infrastructureImages[activeInfrastructureSlide]} alt={infrastructureSlides[activeInfrastructureSlide].title} />
                <div className="condominium-infrastructure-slide-shade" />
                <button type="button" className="condominium-infrastructure-slide-image-open" aria-label={`Abrir ${infrastructureSlides[activeInfrastructureSlide].title}`} onClick={() => setInfrastructureDetailsOpen(true)} />
                <button type="button" className="condominium-carousel-arrow condominium-infrastructure-slide-previous" aria-label="Espaço anterior" onClick={() => { setActiveInfrastructureSlide((index) => (index - 1 + infrastructureSlides.length) % infrastructureSlides.length); setInfrastructureDetailsOpen(false); }}><ArrowIcon /></button>
                <button type="button" className="condominium-carousel-arrow condominium-infrastructure-slide-next" aria-label="Próximo espaço" onClick={() => { setActiveInfrastructureSlide((index) => (index + 1) % infrastructureSlides.length); setInfrastructureDetailsOpen(false); }}><ArrowIcon /></button>
                <button type="button" className="condominium-infrastructure-slide-toggle" onClick={() => setInfrastructureDetailsOpen(true)}>
                  <span className="condominium-infrastructure-slide-number">{String(activeInfrastructureSlide + 1).padStart(2, "0")} / {String(infrastructureSlides.length).padStart(2, "0")}</span>
                  <strong>{infrastructureSlides[activeInfrastructureSlide].title}</strong>
                  <span className="condominium-infrastructure-slide-hint">Ver detalhes<ArrowIcon /></span>
                </button>
              </div>
              <div className="condominium-infrastructure-carousel-controls">
                <div className="condominium-infrastructure-carousel-dots" aria-label="Escolher espaço">
                  {infrastructureSlides.map((slide, index) => (
                    <button type="button" key={slide.title} className={index === activeInfrastructureSlide ? "is-active" : ""} aria-label={`Mostrar ${slide.title}`} aria-current={index === activeInfrastructureSlide ? "true" : undefined} onClick={() => { setActiveInfrastructureSlide(index); setInfrastructureDetailsOpen(false); }} />
                  ))}
                </div>
              </div>
              {infrastructureDetailsOpen && (
                <div className="condominium-infrastructure-viewer-layer" onClick={() => setInfrastructureDetailsOpen(false)}>
                  <div className="condominium-infrastructure-viewer" role="dialog" aria-modal="true" aria-label={infrastructureSlides[activeInfrastructureSlide].title} onClick={(event) => event.stopPropagation()}>
                    <button type="button" className="condominium-infrastructure-viewer-close" aria-label="Fechar visualização" onClick={() => setInfrastructureDetailsOpen(false)}><CloseIcon /></button>
                    <div className="condominium-infrastructure-viewer-image-wrap">
                      <img src={infrastructureImages[activeInfrastructureSlide]} alt={infrastructureSlides[activeInfrastructureSlide].title} />
                      <button type="button" className="condominium-carousel-arrow condominium-viewer-previous" aria-label="Espaço anterior" onClick={() => setActiveInfrastructureSlide((index) => (index - 1 + infrastructureSlides.length) % infrastructureSlides.length)}><ArrowIcon /></button>
                      <button type="button" className="condominium-carousel-arrow condominium-viewer-next" aria-label="Próximo espaço" onClick={() => setActiveInfrastructureSlide((index) => (index + 1) % infrastructureSlides.length)}><ArrowIcon /></button>
                    </div>
                    <div className="condominium-infrastructure-viewer-copy">
                      <span>{String(activeInfrastructureSlide + 1).padStart(2, "0")} / {String(infrastructureSlides.length).padStart(2, "0")}</span>
                      <h3>{infrastructureSlides[activeInfrastructureSlide].title}</h3>
                      <p>{infrastructureSlides[activeInfrastructureSlide].description}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}


          <div className="condominium-amenities">

            {infrastructure.items?.map((item) => (
              <div
                className="condominium-amenity"
                key={item}
              >

                <span className="condominium-amenity-icon">
                  <CheckIcon />
                </span>

                <span>{item}</span>

              </div>
            ))}

          </div>

          {sectionActions("#plantas", "Conheça as plantas", "infrastructure")}

        </div>

      </section>


      {/* =========================================================
          PLANTAS
      ========================================================= */}

      <section
        className="condominium-plants"
        id="plantas"
      >

        <div className="condominium-container">

          <div className="condominium-section-header condominium-section-header-centered condominium-plants-header">

            <span className="condominium-eyebrow condominium-eyebrow-dark">
              PLANTAS
            </span>

            <h2>{plants.title}</h2>

          </div>


          {plants.items?.length > 0 && (
            <div className="condominium-plants-carousel" role="region" aria-roledescription="carrossel" aria-label="Plantas dos apartamentos">
              {(() => {
                const plant = plants.items[activePlantSlide];
                const image = plant.image || plantImages[activePlantSlide];
                return (
                  <article className="condominium-plant-card" key={activePlantSlide}>
                    <div className="condominium-plant-image">
                      {image ? <img src={image} alt={plant.title} /> : (
                        <div className="condominium-plant-placeholder">
                          <span>Planta {String(activePlantSlide + 1).padStart(2, "0")}</span>
                          <small>Imagem da planta em breve</small>
                        </div>
                      )}
                      {plants.items.length > 1 && <>
                        <button type="button" className="condominium-carousel-arrow condominium-plant-previous" aria-label="Planta anterior" onClick={() => setActivePlantSlide((index) => (index - 1 + plants.items.length) % plants.items.length)}><ArrowIcon /></button>
                        <button type="button" className="condominium-carousel-arrow condominium-plant-next" aria-label="Próxima planta" onClick={() => setActivePlantSlide((index) => (index + 1) % plants.items.length)}><ArrowIcon /></button>
                        <span className="condominium-plant-slide-count" aria-live="polite">{activePlantSlide + 1} / {plants.items.length}</span>
                      </>}
                    </div>
                  </article>
                );
              })()}
              {plants.items.length > 1 && (
                <div className="condominium-plant-carousel-dots" aria-label="Escolher planta">
                  {plants.items.map((plant, index) => (
                    <button key={plant.title} type="button" className={index === activePlantSlide ? "is-active" : ""} aria-label={`Mostrar ${plant.title}`} aria-current={index === activePlantSlide ? "true" : undefined} onClick={() => setActivePlantSlide(index)} />
                  ))}
                </div>
              )}
            </div>
          )}

          {sectionActions("#galeria", "Conheça a galeria", "plants")}

        </div>

      </section>


      {/* =========================================================
          GALERIA
      ========================================================= */}

      {galleryImages.length > 0 && (
        <section className="condominium-gallery" id="galeria">

          <div className="condominium-container">

            <div className="condominium-section-header">

              <div>

                <span className="condominium-eyebrow condominium-eyebrow-dark">
                  GALERIA
                </span>

                <h2>
                  Conheça o empreendimento
                </h2>

              </div>

              <p>
                Uma visão dos espaços e detalhes que fazem parte
                do Raízes Residencial Clube.
              </p>

            </div>


            <div className="condominium-property-gallery">
              <div className="condominium-property-gallery-main">
                <img
                  src={galleryImages[activeGalleryImage]}
                  alt={`Raízes Residencial Clube - imagem ${activeGalleryImage + 1}`}
                  role="button"
                  tabIndex={0}
                  aria-label="Ampliar imagem da galeria"
                  onClick={() => setGalleryViewerOpen(true)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      setGalleryViewerOpen(true);
                    }
                  }}
                />
                <button type="button" className="condominium-property-gallery-arrow is-previous" aria-label="Imagem anterior" onClick={() => changeGalleryImage(-1)}><ArrowIcon /></button>
                <button type="button" className="condominium-property-gallery-arrow is-next" aria-label="Próxima imagem" onClick={() => changeGalleryImage(1)}><ArrowIcon /></button>
              </div>

              <div className="condominium-property-gallery-thumbnails">
                {galleryImages.slice(1, 4).map((image, visibleIndex) => {
                  const imageIndex = visibleIndex + 1;
                  const isMoreTile = visibleIndex === 2 && galleryImages.length > 4;
                  return (
                    <button
                      type="button"
                      key={image}
                      className={`condominium-property-gallery-thumbnail ${activeGalleryImage === imageIndex ? "is-active" : ""} ${isMoreTile ? "is-more" : ""}`}
                      aria-label={isMoreTile ? `Ver todas as ${galleryImages.length} imagens` : `Abrir imagem ${imageIndex + 1}`}
                      onClick={() => openGalleryViewer(imageIndex)}
                    >
                      <img src={image} alt={`Raízes Residencial Clube - imagem ${imageIndex + 1}`} />
                      {isMoreTile && <span className="condominium-property-gallery-more"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 4h-4l-1.5 2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.5L14 4Z" /><circle cx="12" cy="13" r="3.5" /></svg><span>Ver todas ({galleryImages.length})</span></span>}
                    </button>
                  );
                })}
              </div>
            </div>

          {sectionActions("#contato-empreendimento", "Fale com um especialista", "gallery")}

          </div>

        </section>
      )}

      {galleryViewerOpen && galleryImages.length > 0 && (
        <div className="condominium-gallery-viewer" role="dialog" aria-modal="true" aria-label="Galeria de imagens do Raízes Residencial Clube">
          <button type="button" className="condominium-gallery-viewer-backdrop" aria-label="Fechar visualizador" onClick={() => setGalleryViewerOpen(false)} />
          <div className="condominium-gallery-viewer-counter">{activeGalleryImage + 1}/{galleryImages.length}</div>
          <button type="button" className="condominium-gallery-viewer-close" aria-label="Fechar visualizador" onClick={() => setGalleryViewerOpen(false)}><CloseIcon /></button>
          <button type="button" className="condominium-gallery-viewer-nav is-previous" aria-label="Imagem anterior" onClick={() => changeGalleryImage(-1)}><ArrowIcon /></button>
          <div className="condominium-gallery-viewer-stage"><img src={galleryImages[activeGalleryImage]} alt={`Raízes Residencial Clube - imagem ${activeGalleryImage + 1}`} /></div>
          <button type="button" className="condominium-gallery-viewer-nav is-next" aria-label="Próxima imagem" onClick={() => changeGalleryImage(1)}><ArrowIcon /></button>
          <div className="condominium-gallery-viewer-thumbnails" aria-label="Miniaturas das imagens">
            {galleryImages.map((image, index) => (
              <button key={image} type="button" className={index === activeGalleryImage ? "is-active" : ""} aria-label={`Abrir imagem ${index + 1}`} aria-current={index === activeGalleryImage ? "true" : undefined} onClick={() => setActiveGalleryImage(index)}><img src={image} alt="" /></button>
            ))}
          </div>
        </div>
      )}


      {/* =========================================================
          CTA FINAL — SEPARADO DO CTA DO HERO
      ========================================================= */}

      <section className="condominium-contact" id="contato-empreendimento">

        <div className="condominium-contact-image">

          <img
            src={condominiumImages.hero}
            alt=""
            aria-hidden="true"
          />

        </div>

        <div className="condominium-contact-overlay" />

        <div className="condominium-container condominium-contact-content">

          <span className="condominium-eyebrow">
            {contact.label}
          </span>

          <h2>
            Venha conhecer o Raízes.
          </h2>

          <p>
            Descubra todos os detalhes do empreendimento e veja
            quais unidades estão disponíveis.
          </p>

          <div className="condominium-section-actions condominium-contact-actions">
            <button type="button" className="condominium-contact-button" onClick={openContact}>Venha conhecer<ArrowIcon /></button>
          </div>

        </div>

      </section>

      {showContact && (
        <div className="condominium-contact-popup-layer" onClick={closeContact}>
          <div className="condominium-hero-contact-panel condominium-contact-popup" role="dialog" aria-modal="true" aria-label="Contato do empreendimento" onClick={(event) => event.stopPropagation()}>
            <button type="button" className="condominium-hero-contact-close" onClick={closeContact} aria-label="Fechar"><CloseIcon /></button>
            <span className="condominium-eyebrow condominium-eyebrow-dark">FALE CONOSCO</span>
            <h3>Venha conhecer<strong> o Raízes.</strong></h3>
            <p>Consulte as unidades disponíveis e agende uma visita ao empreendimento.</p>
            <a className="condominium-hero-contact-whatsapp" href={contact.whatsapp} target="_blank" rel="noopener noreferrer">Falar pelo WhatsApp<ArrowIcon /></a>
            <button type="button" className="condominium-hero-contact-minimize" onClick={closeContact}>Fechar</button>
          </div>
        </div>
      )}

    </main>
  );
};

export default Condominium;
